import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService, GenericValue } from 'hisng';
import { ResearchContractIncome } from '../../model/finance/research-contract-classes';

@Injectable()
export class FinancingTypeValueService {

    constructor(private backendService: HisBackendService) { }

    public getBudgetSourceTypeValuesByHiskeyIds(hiskeyIds: string): Observable<GenericValue[]> {
        return this.backendService.getData('api/v1/cs/sys/values/budgetSourceTypeValue?hisKeyIds='+hiskeyIds);
    }

    public validateResearchsFundIncomes( target: string, researchContractIncome: ResearchContractIncome ) {
        return this.backendService.postData( 'api/v1/fs/res/'+target+'/validateResearchsFundIncomes', researchContractIncome );
    }
}
